import Layout from "@/layouts/default/main"

export default {
    path: "/user",
    name: "User",
    redirect: "/user/index",
    component: Layout,
    children: [{
        path: "index",
        name: "UserIndex",
        component: () => import("@/views/user/index")
    }]
}